import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
    computed,
    OnInit,
} from "@angular/core";
import { S25IconComponent } from "../../../../s25-icon/s25.icon.component";
import { Table } from "../../../../s25-table/Table";
import { Bind } from "../../../../../decorators/bind.decorator";
import { S25EventOccurrencesService } from "../../s25.event.occurrences.service";
import { S25Reservation } from "../../../ReservationI";
import ActionI = Table.ActionI;
import { ShowDetailsUtil } from "./occurrence.show.details.utilt";

@Component({
    selector: "occurrence-segment",
    template: ` @if (init) {
        <div class="occ-expand-all-segment" (click)="showDetails('autoClick')"></div>
        <div class="occ-segment-wrapper">
            @if (eventState && (eventState === 98 || eventState === 99)) {
                <div>{{ segmentName }}</div>
            }
            @if ((eventState && eventState !== 98 && eventState !== 99) || (occ.state !== 99 && occ.state !== 2)) {
                <button
                    (click)="showDetails('manualClick')"
                    class="c-textButton toggle-details-button"
                    [class.expanded]="toggleShowDetails"
                >
                    <s25-ng-icon [type]="'caretRight'" [ariaLabel]="false" />
                    <div>{{ segmentName }}</div>
                </button>
            }
        </div>
    }`,
    styles: [
        `
            ::ng-deep .occ-segment-wrapper {
                min-width: 149px;
            }

            ::ng-deep .toggle-details-button {
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            .expanded {
                --icon--rotation-degrees: 90deg;
            }

            ::ng-deep .c-svgIcon:hover {
                cursor: pointer;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    imports: [S25IconComponent],
})
export class OccurrenceSegmentComponent implements OnInit {
    @Input() segmentName: string;
    @Input() occ: S25Reservation;
    @Input() eventState: number;

    @Output() toggleDetailsRow: EventEmitter<Table.NewRowModel> = new EventEmitter<Table.NewRowModel>();

    toggleShowDetails: boolean = false;
    init: boolean = false;

    isExpandAll = computed(() => {
        return this.occurrencesService.getExpandAll();
    });

    occurrence = computed(() => {
        return this.occurrencesService.getOccurrences().find((rsrv) => rsrv.itemId === this.occ.itemId);
    });

    constructor(
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
        private occurrencesService: S25EventOccurrencesService,
    ) {}

    ngOnInit() {
        this.init = true;
    }

    @Bind
    showDetails(caller: "autoClick" | "manualClick") {
        const lastCallertTags = this.occurrencesService.getCallerTags();
        this.occurrencesService.setCallerTags(".occ-expand-all-segment");
        const { toggleShowDetails, action } = ShowDetailsUtil.showDetailsUtil({
            caller,
            toggleShowDetails: this.toggleShowDetails,
            isExpandAll: this.isExpandAll(),
            occ: this.occurrence(),
            lastCallerTags: lastCallertTags,
            currentCallerTags: this.occurrencesService.getCallerTags(),
        });

        let table, row, allrows;
        if (window.innerWidth < 540) {
            // access HTML table elements when table is pivoted
            table = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement;
            row = this.elementRef.nativeElement.parentElement.parentElement;
            allrows = table.children[1].children;
        } else {
            table = this.elementRef.nativeElement.offsetParent.offsetParent;
            row = this.elementRef.nativeElement.offsetParent.parentElement;
            allrows = table.children[2].children;
        }

        const tableData: Table.NewRowModel = {
            table: table,
            row: row,
            rowIndex: Array.from(allrows).indexOf(row) - (window.innerWidth < 540 ? 1 : 0),
            action: action as ActionI,
            data: { occ: this.occurrence(), isCopy: false },
        };
        this.toggleShowDetails = toggleShowDetails;
        this.toggleDetailsRow.emit(tableData);
        this.cd.detectChanges();
    }
}
